export default __webpack_public_path__ + "static/media/about-4.e9304b17.jpg";